export default __webpack_public_path__ + "static/media/sideMenu_dashboard.a3a2e105.svg";